/* PabDer — header drawer (Woman/Man shop + PabDer World) */
(function(){
  function init(){
    var scrim=document.getElementById('pwScrim');
    var shop=document.getElementById('shopMenu');
    var pw=document.getElementById('pwMenu');
    var triggers={
      woman:document.getElementById('shopWoman'),
      man:document.getElementById('shopMan'),
      pw:document.getElementById('pwTrigger'),
      mobile:document.getElementById('mobileMenuBtn')
    };
    if(!scrim||!shop||!pw||!triggers.woman) return;
    var current=null, shopTab='root';
    var mmBack=document.getElementById('mmBack');
    var mmClose=document.getElementById('mmClose');
    var mmTitle=document.getElementById('mmTitle');
    var titles={root:'Menu',woman:'Woman',man:'Man'};

    function paint(){
      [triggers.woman,triggers.man,triggers.pw].forEach(function(t){if(t){t.classList.remove('open');t.setAttribute('aria-expanded','false');}});
      if(current==='pw'&&triggers.pw){triggers.pw.classList.add('open');triggers.pw.setAttribute('aria-expanded','true');}
      if(current==='shop'&&shopTab!=='root'&&triggers[shopTab]){triggers[shopTab].classList.add('open');triggers[shopTab].setAttribute('aria-expanded','true');}
      if(triggers.mobile){triggers.mobile.setAttribute('aria-expanded',current==='shop'?'true':'false');}
    }
    function show(which){
      [shop,pw].forEach(function(m){m.classList.toggle('open',(which==='shop'&&m===shop)||(which==='pw'&&m===pw));});
      var on=which!==null;
      scrim.classList.toggle('open',on);
      document.body.classList.toggle('mm-open',on);
      document.body.style.overflow=on?'hidden':'';
      current=which; paint();
    }
    function setTab(t){
      shopTab=t;
      shop.querySelectorAll('.mm-panel').forEach(function(p){p.classList.toggle('on',p.dataset.panel===t);});
      if(mmBack) mmBack.style.visibility = (t==='root') ? 'hidden' : 'visible';
      if(mmTitle) mmTitle.textContent = titles[t] || 'Menu';
      paint();
    }
    triggers.woman.addEventListener('click',function(e){e.stopPropagation();if(current==='shop'&&shopTab==='woman')show(null);else{setTab('woman');show('shop');}});
    triggers.man.addEventListener('click',function(e){e.stopPropagation();if(current==='shop'&&shopTab==='man')show(null);else{setTab('man');show('shop');}});
    triggers.pw.addEventListener('click',function(e){e.stopPropagation();show(current==='pw'?null:'pw');});
    if(triggers.mobile){
      triggers.mobile.addEventListener('click',function(e){e.stopPropagation();if(current==='shop')show(null);else{setTab('root');show('shop');}});
    }
    shop.querySelectorAll('[data-goto]').forEach(function(b){
      b.addEventListener('click',function(e){
        e.stopPropagation();
        var g=b.getAttribute('data-goto');
        if(g==='pw'){show('pw');} else {setTab(g);}
      });
    });
    if(mmBack) mmBack.addEventListener('click',function(e){e.stopPropagation();setTab('root');});
    if(mmClose) mmClose.addEventListener('click',function(e){e.stopPropagation();show(null);});
    scrim.addEventListener('click',function(){show(null);});
    document.addEventListener('keydown',function(e){if(e.key==='Escape'&&current)show(null);});
    [shop,pw].forEach(function(m){m.addEventListener('click',function(e){if(e.target.closest('a'))show(null);});});
  }
  if(document.readyState!=='loading') init();
  else document.addEventListener('DOMContentLoaded',init);
  document.addEventListener('shopify:section:load',init);
})();
